import styled from 'styled-components';

export const StyledSlash = styled.div`
  &:after {
    content: '\\00a0/\\00a0';
  }
`;
